var _style, _defs, _g, _circle, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCroatia = function SvgCroatia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Croatia_svg__F{fill:#ed2224}.Croatia_svg__G{fill:#995c25}.Croatia_svg__H{fill:#fed810}.Croatia_svg__I{fill:#fff}.Croatia_svg__J{fill:#46a1da}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Croatia_svg__A"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -120.2,
    cy: 100.6,
    r: 97.2,
    fill: "none",
    transform: "rotate(315 -120 101)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Croatia_svg__B"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 98.7,
    r: 96.4,
    fill: "none",
    transform: "rotate(315 101 99)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Croatia_svg__A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#66b0e1",
    d: "M-266 3H26v195h-292z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-266 3H26v97h-292z",
    className: "Croatia_svg__I"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 98.7,
    r: 96.4,
    fill: "none",
    stroke: "#a5a7aa",
    strokeWidth: 1.8,
    transform: "rotate(315 101 99)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Croatia_svg__B)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-44 2h289v193H-44z",
    className: "Croatia_svg__I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44 2h289v64H-44z",
    className: "Croatia_svg__F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a3e98",
    d: "M-44 131h289v64H-44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 150c-11 0-20-4-28-12-7-7-11-17-11-27V65h77v46c0 21-17 39-38 39",
    className: "Croatia_svg__I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 67h75v44c0 21-17 38-37 38-21 0-38-17-38-38V66m-2-2v47a40 40 0 0 0 79 0V64z",
    className: "Croatia_svg__F"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "m137 66 8-20-6-11-11 4-8-9-10 6-9-7-9 7-11-6-7 9-12-4-6 11 9 20a87 87 0 0 1 72 0Z",
    className: "Croatia_svg__I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136 65 9-19-6-10-11 4-6 20z",
    className: "Croatia_svg__J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139 59 2-5-16-5-1 5z",
    className: "Croatia_svg__F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a3491",
    d: "m92 37-11-6-7 9 5 20 14-2-2-21Zm36 3-8-9-10 6-2 21 15 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74 40-11-4-7 10 9 19 14-5z",
    className: "Croatia_svg__J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 69H65v15h14zm0 31h14V84H79zm-14 11v4h14v-15H65zm43-11H93v15h15zm0 31h14v-16h-14zm14 8 8-8h-8zm-43-8h14v-16H79zm-8 0 8 8v-8zm32 15h5v-15H93v15zm33-31v-15h-14v15zm-28-15h14V84h-14zm0-31H93v15h15zm28 15V69h-14v15z",
    className: "Croatia_svg__F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73 50 1 3c0 3-3 5-6 5s-5-2-5-4c1 1 3 3 5 3 3 0 5-3 5-6z",
    className: "Croatia_svg__I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77 55 16-2-1-6-16 3zm-2-10 17-3v-5l-18 3z",
    className: "Croatia_svg__F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124 54 15 5-1 1-14-5zm17 0 1-1-16-5-1 1z",
    className: "Croatia_svg__I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65 42 1 1h2v2l1 1-2 1v2l-2-2-2 1 1-2-2-1 2-1z",
    className: "Croatia_svg__G"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Croatia_svg__H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66 45 3 1-1-1zm-3 0h3l-2-1zm3 0h-3l1 1zm3 1-3-1 1 2zm-3-1 2-2-2 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 48 2-3-2 1zm2-2-2 2 1-1zm2-3-2 2h2zm-2 2-1-3-1 2zm1 4-1-3-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66 46 1 3v-2zm-1-4 1 3v-1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m137 40-1 1-2-1v2l-1 2h2v2l2-1 2 1-1-2 2-2h-2z",
    className: "Croatia_svg__G"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Croatia_svg__H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m136 43-3 1 1-2zm3-1-3 1 2-1zm-3 1 3-1-1 2zm-3 1 3-1-1 1zm3-1-2-3 2 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138 45-2-2 2 1zm-2-2 2 3-1-1zm-2-2 2 2-2-1zm2 2 1-3 1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135 46 1-3 1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136 43-1 3v-2zm1-3-1 3v-2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m110 37-10-7-8 7 1 21 8-1 7 1z",
    className: "Croatia_svg__J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 47h-1v1h-1l-1-1v2h-1l1 1h-1l1 1-1 1h1v1h1l-1 1h3v-1h2v-2l1-1h-1v-1h-1l1-1v-1l-1 1h-1zl-1-1z",
    className: "Croatia_svg__G"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 49h1zm1 0h-5zm0-1c-1 0 0-1 0 0v-1zh-2c1 0 1-1 0 0v-1h-1v1c0-1 0 0 0 0h-1l-1-1v1zm0 1h-4c1 1 1 0 0 0h-1 1v1-1 1-1h-1l1 1v1-1h-1l1 1-1-1 1 1v1q0-1.5 0 0s0-1 0 0h-1 2l-1 1 1-1-1 1v-1l1 1h-1 1l-1 1 1-1-1 1 1-1v1-1 1h1v1-2l1 1v-1 1-1h1-1 1l-1-1 1 1-1-1h2-1v-1h1-1 1-1l1-2-1 1zv1zh-1zm0 0h-4zm0 0c-1 0 0-1 0 0v-1h-5v1zm-1 0c-1 0 0 0 0 0h-1zm0 0c-1 0 0 0 0 0m-2 0h1zm1 0h-1zm-2 0h1zm1 0h-1z",
    className: "Croatia_svg__H"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 48h-1l1-1zm0 0v-1l-1 1zm0 4v1zm-1 0v1zm0 1v-1h1-1zh1zm0 0h1zm1-3h1zm-1 0h-1zm0 0v1h-1v-1l1 1zm0 1-1-1zm1-1v1l1-1v1h-1v-2Zm0 1h1v-1zm0 0h1zm0 0h1zm-5-14v1l-1 1q0-1.5 0 0l-1-1h-1l1 1v1h-1l1 1h-1l1 1v1c-1 0 0 0 0 0v1h1v1h1c0 1 0 0 0 0h3l-1-1h1v-1h1l-1-1 1-1h-1v-2c0 1 0 0 0 0v-1l-1 1h-1v-1h-1Z",
    className: "Croatia_svg__G"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Croatia_svg__H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 39s0 1 0 0m1 0h-5zm0 0v-1zv-1h-1v1h-1s0-1 0 0v-1h-1v1h-1l-1-1v1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 40h-2 1-3 1-1l-1-1v1h1-1 1-1l1 1h-1 1-1l1 1s0-1 0 0h-1 1l-1 1c1 0 2-1 0 0l2-1-1 1h1-1 1-1 1v1-1 1h-1 1s1-1 0 0h1s0-1 0 0h1v-1 1-1h-1 1v1-1l1 1-1-1 1 1v-1h-1 1-1 1v-1 1-1h-1 2c-2 0-1 0 0 0h-1 1l-1-1h1-1 1-1l1-2v1zv-1zv-1h1-1zm-2 0h-2 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98 40 1-1h-5v1h5zm-1 0h1zm0 0h1zm-1 0c1 0 0-1 0 0m1 0c0-1-1 0 0 0m-2 0h1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97 39h-1v-1h1zm0 0v-1h-1v1zm1 4-1 1zm0 0h-1zm-2 0v1zm0 1h1v-1h-1 1c0-1 0 0 0 0v1zm0 0h1zm1-3h1zm-1-1v2l-1-1h1zm0 1h-1zv1zm1-1v1h1-1zm1 1h-1v1zm-1 0h1zm0 0h1zm-1 0v1zm0 0v1zm0 0s-1 0 0 0m9-3 1 1v-1h1v2h1l-1 1h1l-1 1v2h-1v1h-1c0 1 0 0 0 0h-1c-1 0-1 1-1-1h-1 1-1v-1h-1l1-1-1-1h1v-1h1l-1-1v-1h1l1 1v-1l1-1z",
    className: "Croatia_svg__G"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Croatia_svg__H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103 39s0 1 0 0m4 1h-1zm0-1h-5zm0 0h-5 1-1v-1h1q0 1.5 0 0l1 1v-1c0 1 0 0 0 0l1-1v1s0 1 0 0v1h1l1-1zm-4 1h3-1 1v1-1h1l-1 1 1-1-1 1 1-1-1 1v1l1-1-1 1 1-1-1 1h1-1l1 1c-1 0-2 0 0 0h-2 1v1-1h-1 1v1l-1-1v1-1l1 1h-1 1-1v1-1 1-1 1h-1v-1 1-1 1-1 1-1 1-1 1-1h-1 1-1v-1l-1 1 1-1-1 1 1-1-1 1 1-1h-1l1-1-1 1 1-1-1-1v1h1l-1-1 1 1-1-1v-1l1 1-1-1 1 1-1-1zm4 0h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 40h-4l-1-1h5zh-1Zm-3 0s0-1 0 0m0-1c0 1-1 0 0 0m1 1s0-1 0 0m1 0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105 39v-1h-1zm0 0-1-1h1zm-1 4v1zm1 0v1zm0 1v-1h-1v1zm0 0h-1zm-1-3h-1zm1 0h1zm0-1v2l1-1c0 1 0 0 0 0h-1Zm0 1h1l-1 1zm-1-1v1h-1c0-1 0 0 0 0h1s0 1 0 0zm-1 1h1v1zh1Zm1 0q0 1.5 0 0m0 0h-1zm1 0q0 1.5 0 0m0 0h1zm0 0",
    className: "Croatia_svg__G"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233770",
    d: "M113 42c4-3 5 1 8 0h-4l5 2h-1c-3 1-4-2-6-2l1 1h-1c0 1 0 0 0 0v2l1 1h2l2 1h3-1v1h-1v4h-1l-1 1v1h-2 1v-1l1-1v-1h-1v1l-1 1h-2l1-1 1-1h-2l-1 1v1h-2 1v-1l1-1v-1h-1v2h-1q-1.5 0 0 0v-1l1-1v-2c-1 0 0 0 0 0v-1q-1.5 0 0 0v-3h-1v-1zh-1v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 42h1l-1 1zm0 0v1h-1v-1zm-5-1h2v1-1l1 1h2-3l-1-1zm-1 0h2z",
    className: "Croatia_svg__F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 51v1c0-1 0 0 0 0zv1l-1 1h-1 1-1 1v-3h1zv-1zv-1zv-1l1 1Z",
    className: "Croatia_svg__H"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Croatia_svg__F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m117 43-1-1h1c0 1 0 0 0 0h1v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117 43 1-1 1 1zm2 1-1-1h1l1 1zm1 0h-1zm2 0h-2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m112 48 1-1zl1-1v1zv1l1-1-1 1v2l-1 1h1v-1l1-1s0-1 0 0v-1 3l-1 1h1v-1l1-1v-1h1-1 1v-1 1h1-1 1v-1h1l-1 1h1v-1 1l1 1v-1 1h1-1 1l-1 2h-2v1h1s-1 0 0 0l1-1c-1 0 0 0 0 0l1-1v-1 1l1-1v-3l1 1v-2 1-1h1s0-1 0 0h-3v-1 1-1h-1l1 1-1-1v1-1h-1l1 1-1-1v1-1 1-1h-2 1-1l1 1-1-1v1-1l-1-1v1-2s0-1 0 0h-1 1v-1h1s-1 0 0 0h-2 1l1-1h-1 1-2 1l-1 1v-1h1-2v1l-1 1v-1q0 1.5 0 0v1h1v1s0 1 0 0h1v-1 1h-1v1l1-1-1 1s0 1 0 0v1q-1.5 0 0 0z",
    className: "Croatia_svg__H"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Croatia_svg__G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119 51h-1zm1 1h-1zm0 0c1-1 1 0 0 0m0-3v1h1v-1l-1 1zm0 1c0-1 0 0 0 0m0 1v-1zm0-1v1zm1 0v1zm-1-2h1zv1zm1-1v1zm-3 0v1zm1 1v1l1-1-1 1zm0 0-1 1h1-1v-1Zm-1 0s0 1 0 0m0 0-1 1h1-1zm1 1v1l-1-1 1 1zm0 1c0-1 1-1 0 0m1 1h-1v-1 1Zm-1-1v1zm-2-4v1zm0 1v1zv1zv1zm0 3v-1zm0-1v1zm0-1v1c-1 0-1 1 0 0zm-1 2v-1l-1 1Zm-1 0h-1zm-1 0c0 1 0 0 0 0m1-2v1zm-1 0v1zm-1 1v1zm2-3h1zm0 1v-1zm-1-1-1 1h1v1zm1-1v1zm-1 1h-1v1-1zm0-1v2zm0 0v1zm2 2v1zm0 1v1zm0 0v1zm0 0v1h-1v-1 1h1zm-1 0v1zm-1 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 49v-2l-1 2zm-1-1v1zm2-1v1zm1 0h-1zm0-1v1zm-1 1v-1zm-2 0v1zm2-1v2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112 42h1l-1 1Z",
    className: "Croatia_svg__H"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 43h1zh1zm2 0h1zm-2 0v1zm0 0h1zm0 0v-1zm0 0h-1zm-1-1h1zm2 3v-1zm-1 0h-1zm10 2",
    className: "Croatia_svg__G"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a171b",
    d: "M127 53h1v-1h-1l-1-1h1v-1l1 1h1v1l2 1h2l3 1 3 1h-1l-2-1v1h1v2h-1s0-1 0 0v-1l-1-1h-3q-1.5 0 0 0l1-1h-5 2l-1-1h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133 55-1-1h-1 2l1 1z",
    className: "Croatia_svg__I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 54h-1 2zm-6-2q-1.5 0 0 0h1zm4 1h-1zh-1zm-3 0v1zv1l1-1zm2-10 1-1h-2 1-1 1zm-2-1h2z",
    className: "Croatia_svg__F"
  }))));
};
export default SvgCroatia;